import axios from "axios";


function mapListItem(item) {
  return {
    id: item.id,
    poCode: item.no || "",
    // prRefCodes: structured array for badge display
    prRefCodes: Array.isArray(item.prNos) && item.prNos.length > 0
      ? item.prNos
      : [],
    // prRefCode: joined string for search filter compatibility
    prRefCode: Array.isArray(item.prNos) && item.prNos.length > 0
      ? item.prNos.join(", ")
      : "",
    vendorCode: item.vendorNo || "",
    vendorName: item.vendorName || "",
    branchName: item.branch?.name || "",
    createdAt: item.creationDt || "",
    status: item.status || "",
    items: [],
  };
}

function mapDetailItem(item) {
  const prRefs = Array.isArray(item.prRelations) && item.prRelations.length > 0
    ? item.prRelations.map((r) => ({ prId: r.prId, prNo: r.prNo }))
    : [];

  return {
    id: item.id,
    poCode: item.no || "",
    prRefCode: prRefs.map((r) => r.prNo).join(", ") || "",
    // New structured multi-PR fields
    prRefs,
    vendorCode: item.vendorNo || "",
    vendorName: item.vendorName || "",
    branchName: item.branch?.name || "",
    createdAt: item.creationDt || "",
    status: item.status || "",
    items: (item.products || []).map(p => ({
      productId: p.productId,
      productCode: p.product?.no || "",
      productName: p.product?.description || "",
      qtyReceived: p.receivedQty ?? 0,
      qtyTotal: p.qty ?? 0,
      remainQty: p.remainQty ?? 0,
      uomId: p.uomId,
      uomName: p.uom?.description2 || p.uom?.description || "",
      unitCost: p.unitCost ?? 0,
    })),
    goodsReceives: (item.goodReceives || []).map(gr => ({
      id: gr.id,
      grCode: gr.grNo || "",
      createdAt: gr.creationDt || "",
    })),
  };
}

const modulePurchaseOrder = {
  namespaced: true,
  state: {
    purchaseOrderList: [],
    purchaseOrderDropdown: [],
    filter: "",
  },
  mutations: {
    setPurchaseOrderList(state, data) {
      state.purchaseOrderList = data;
    },
    setPurchaseOrderDropdown(state, data) {
      state.purchaseOrderDropdown = data;
    },
    setFilter(state, value) {
      state.filter = value;
    },
  },
  actions: {
    async fetchPurchaseOrderList({ commit }, { clinicUrl, branchUrl }) {
      try {
        const res = await axios.get(`/api/po/${clinicUrl}/${branchUrl}`);
        const mappedData = (res.data.data || []).map(mapListItem);
        commit("setPurchaseOrderList", mappedData);
        return mappedData;
      } catch (err) {
        console.error("fetchPurchaseOrderList failed", err);
        throw err;
      }
    },
    async fetchPurchaseOrderDropdown({ commit }, { clinicUrl, branchUrl }) {
      try {
        const res = await axios.get(`/api/po/${clinicUrl}/${branchUrl}/dropdown`);
        const data = res.data.data || [];
        commit("setPurchaseOrderDropdown", data);
        return data;
      } catch (err) {
        console.error("fetchPurchaseOrderDropdown failed", err);
        throw err;
      }
    },
    async fetchPurchaseOrderById(_, { clinicUrl, branchUrl, id }) {
      try {
        const res = await axios.get(`/api/po/${clinicUrl}/${branchUrl}/${id}`);
        return mapDetailItem(res.data.data);
      } catch (err) {
        console.error("fetchPurchaseOrderById failed", err);
        throw err;
      }
    },
  },
  getters: {
    getPurchaseOrderList: state => state.purchaseOrderList,
    getPurchaseOrderDropdown: state => state.purchaseOrderDropdown,
    getPoFilter: state => state.filter,
  },
};

export default modulePurchaseOrder;
